import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';

export class DraftConfirmationDialogComponent implements ng.IController {
  public modalInstanceService: ng.ui.bootstrap.IModalInstanceService = this as any;
  public resolve: {
    items: string[]
  };

  public onSave() {
    this.modalInstanceService.close({ $value: true });
  }

  public onClose() {
    this.modalInstanceService.close({ $value: false });
  }
}

angular.module('naut').component('draftConfirmationDialog', {
  template: require('./draft-confirmation-dialog.component.html'),
  controller: DraftConfirmationDialogComponent,
  controllerAs: 'ctrl',
  bindings: {
    resolve: '<',
    close: '&'
  }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/products/components/draft-confirmation-dialog/draft-confirmation-dialog.component.ts